import { get } from 'lodash';

export type ContactTypes = 'telegram' | 'email' | 'phone' | 'skype';
const ORDERED_KEYS: ContactTypes[] = ['telegram', 'phone', 'email', 'skype'];

const isPrimaryContact = (contact: AH$ProfileContact): boolean =>
  Boolean(get(contact, ['sourceInfo', 'corporate'])) === false;

export const getContactsIdByImportance = (
  ids: Array<number>,
  contactsById: { [key: number]: AH$ProfileContact }
): {
  primary: Array<number>;
  secondary: Array<number>;
} => ({
  primary: ids.filter((id) => isPrimaryContact(contactsById[id])),
  secondary: ids.filter((id) => !isPrimaryContact(contactsById[id])),
});

export const groupingContacts = (profile: AH$Profile) =>
  Object.entries(Object.fromEntries(profile.contactsIdByType)).reduce(
    (acc, [contactType, contactsIds]) => {
      if (!['email', 'phone', 'skype', 'telegram'].includes(contactType)) {
        return acc;
      }

      acc[contactType as ContactTypes] = contactsIds.map(
        (contactId) => profile.contactsById[contactId]
      );
      return acc;
    },
    {} as { [K in ContactTypes]: AH$ProfileContact[] }
  );

export const sortGroupedContacts = (groupedContacts: ReturnType<typeof groupingContacts>) =>
  ORDERED_KEYS.reduce((acc, contactType) => {
    if (Object.hasOwn(groupedContacts, contactType)) {
      acc[contactType] = groupedContacts[contactType];
    }

    return acc;
  }, {} as { [K in ContactTypes]: AH$ProfileContact[] });

export const hasMaskedContactsValues = (sortedContacts: ReturnType<typeof sortGroupedContacts>) =>
  Object.values(sortedContacts)
    .reduce((acc, items) => {
      acc.push(...items);
      return acc;
    }, [])
    .some((item) => item.value.includes('*'));
